/*=========================================================================================
File Name: actions.js
Description: All the actions functionality of carts are here.
Version: 1.0
----------------------------------------------------------------------------------------
Item Name: V-Pizzle - VueJS Pizza & Fast Food Template
Author: Deveable
Author URL: https://www.templatemonster.com/authors/deveable/
Copyright 2021
==========================================================================================*/

export default {
  addToCart({commit, state}, payload) {
    /** This is the action hook of cart,  add product into carts **/
    let products = state.items;
    let indexOf = products.findIndex((item) => item.sku === payload.sku);

    if (indexOf > -1) {
      products[indexOf].quantity = Number(products[indexOf].quantity) + Number(payload.quantity);
    } else {
      products.push(payload);
    }
    commit('SET_CARTS', products);
  },
  removeItem({commit, state}, payload) {
    /** This is the action hook of cart,  add product into carts **/
    let products = state.items;
    let indexOf = products.findIndex((item) => item.sku === payload.sku);

    if (indexOf > -1) {
      products.splice(indexOf, 1);
    }

    commit('SET_CARTS', products);
  }
}



// WEBPACK FOOTER //
// ./src/store/carts/actions.js